// --------------------------------------------------------------------------
// exhibitSlider.js
// --------------------------------------------------------------------------
// Slick slider for exhibit listings
// --------------------------------------------------------------------------

RN.exhibitSlider = (function (el) {
    "use strict";

    function init(el) {
        el = $(el);
        var slider = el.find('[data-behaviour="exhibit-slider"]');
        var filters = el.find('[data-behaviour="whats-on-filter"]');
        var currentFilter;
        filters.first().prop("checked", true);
        const type = el.data("type");

        const options = {
            centerMode: true,
            variableWidth: true,
            slidesToShow: 3,
            centerPadding: "20px",
            responsive: [
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        };

        if (type === "external-cards") {
            options.centerMode = false;
            options.centerPadding = "0";
            options.variableWidth = false;
            options.responsive = [
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 675,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ];
        }

        if (slider.length > 0) {
            slider.slick(options);

            if (filters.length > 0) {
                filters.on("change", filterHandler);
                $(filters[0]).trigger("change");

                $(window).on("resize", function () {
                    setTimeout(function () {
                        $('[data-behaviour="whats-on-filter"]:checked').trigger(
                            "change"
                        );
                    }, 100);
                });
            } else {
                postfilterCheck();
                $(window).on("resize", function () {
                    setTimeout(function () {
                        postfilterCheck();
                    }, 100);
                });
            }
        }

        function filterHandler() {
            if (this.checked) {
                $(this)
                    .closest(".whats-on-filter")
                    .siblings()
                    .find('[data-behaviour="whats-on-filter"]')
                    .prop("checked", false);
                currentFilter = "." + this.value;
                if (this.value === "all") {
                    slider.slick("slickUnfilter");
                    return false;
                }
                slider.slick("slickUnfilter");
                slider.slick("slickFilter", currentFilter);

                if (type !== "external-cards") {
                    postfilterCheck();
                }
            } else {
                currentFilter = "";
                slider.slick("slickUnfilter");
            }
        }

        function postfilterCheck() {
            var track = slider.find(".slick-track"),
                slides = track.children(),
                slideCount = slides.length,
                slidesToShow = slider.slick("slickGetOption", "slidesToShow"),
                slideWidth,
                leftAmount;

            if (slideCount <= slidesToShow && slideCount > 0) {
                slideWidth = slides.first().outerWidth();
                leftAmount =
                    ((slideCount - 1) * slideWidth) / 2 + (slideCount - 1) * 10;
                track.css("left", -leftAmount);
                slides.attr("aria-hidden", "false");
            } else {
                track.css("left", "auto");
            }
        }
    }

    return {
        init: init,
    };
})();
